export const getThumbnailUrls = baseUrl => {
  const formatUrl = (url, width) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}fmt=auto&wid=${width}&sm=aspect&aspect=1:1`;
  };

  const src = formatUrl(baseUrl, 48);
  const srcset = [
    `${src} 1x`,
    `${formatUrl(baseUrl, 96)} 2x`,
    `${formatUrl(baseUrl, 144)} 3x`,
  ].join(', ');

  return { src, srcset };
};
